<template>
  <div id="app">
    <main-head
      v-if="!isApp && isLogin"
      @loginoutsuccess="loginoutsuccess"
    />
    <router-view />
  </div>
</template>

<script>
import MainHead from './components/Common/MainHead.vue'
export default {
  name: 'App',
  components: { MainHead },
  data () {
    return {
      isLogin: true,
      isApp: false
    }
  },
  mounted () {
    let token = localStorage.getItem('token')
    if (!token) {
      this.isLogin = false
    } else {
      this.isLogin = true
    }
    var sUserAgent = navigator.userAgent.toLowerCase()
    if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
      this.isApp = true
    } else {
      this.isApp = false
    }
    this.$root.eventHub.$on('setlogin-status', () => {
      this.isLogin = true
    })
  },
  methods: {
    loginoutsuccess () {
      this.isLogin = false
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'FZYongKeTiS';
  src: url('./static/font/FZYongKTJ_Cu.ttf');
}
#app {
  font-family: 'Arial', Microsoft YaHei, sans-serif, Helvetica;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #606266;
  height: 100%;
}
body {
  background: #f8f8f8;
}
</style>
